export const getPriceMatchingFAQ = (isBaby = false) => {
  if (isBaby) {
    return '/faq/baby_price_match';
  }

  return '/faq/115002838511-does-zola-offer-price-matching-what-is-zola-s-price-matching-policy-';
};

export const getVenmoContributionFAQ = (isBaby = false) =>
  isBaby ? '/faq/venmo' : '/faq/7296053720077-how-do-venmo-contributions-work-';

export const getBackorderCancellationFAQ = (isBaby = false) =>
  isBaby
    ? '/faq/my-order-is-backordered-how-can-i-cancel-it'
    : '/faq/360046971072-my-order-is-backordered-how-can-i-cancel-it-';

export const getAddFromOtherStoreFAQ = (isBaby = false) =>
  isBaby
    ? '/faq/how-can-i-add-individual-items-from-another-store-to-my-zola-baby-registry'
    : '/faq/category/115000342372-registry/115000736191-adding-gifts-and-registries-from-other-stores';

export const getShippingExclusionFAQ = (isBaby = false) =>
  isBaby
    ? '/faq/where-can-zola-baby-products-be-shipped'
    : '/faq/where-can-zola-products-be-shipped';

export const getCashTransferTimingFAQ = (isBaby = false) =>
  isBaby
    ? '/faq/how-long-will-it-take-to-receive-our-cash-after-a-transfer-is-requested'
    : '/faq/115002836412-how-long-will-it-take-to-receive-our-cash-after-a-transfer-is-requested-';

export const getCashFundSettingsFAQ = (isBaby = false) =>
  isBaby
    ? '/faq/how-do-we-choose-who-covers-the-2-5-credit-card-processing-fee-for-cash'
    : '/faq/115002836332-how-do-we-choose-who-covers-the-2-5-credit-card-processing-fee-for-cash-gifts-';
